<template>
    <div :class="`as-is-first-score ${mode}`">
        <div class="as-is-first-score__head">
            <IconGoalScored fill="#FFAE00"/>
            <span> Đội nào sẽ ghi bàn đầu tiên?  </span>
        </div>
        <div class="as-is-first-score__body">
            <div class="as-item">
                <div class="as-item__left">
                    <div class="as-team">
                        <div class="as-team__img">
                            <img :src="getImageUrl(footyStats?.home_image)">
                        </div>
                        <div class="as-team__info">
                            {{ footyStats?.home_name }}
                        </div>
                    </div>
                    <div class="as-line">
                        <div class="as-line__as-main">

                        </div>
                        <div class="as-line__as-W" :style="{
                            width: `${ getValueWithMode('home', 'firstGoalScoredPercentage_overall', false, false) }%`
                        }">

                        </div>
                    </div>
                </div>
                <div class="as-item__right">
                    <span>{{ getValueWithMode('home', 'firstGoalScoredPercentage_overall', false, false) }}%</span>
                    <span>Ghi bàn đầu tiên trong {{ getValueWithMode('home', 'firstGoalScored_overall', false, false) }}/{{ getValueWithMode('home', 'seasonMatchesPlayed_overall', false, false) }} trận</span>
                </div>
            </div>
            <div class="as-item">
                <div class="as-item__left">
                    <div class="as-team">
                        <div class="as-team__img">
                            <img :src="getImageUrl(footyStats?.away_image)">
                        </div>
                        <div class="as-team__info">
                            {{ footyStats?.away_name }}
                        </div>
                    </div>
                    <div class="as-line">
                        <div class="as-line__as-main">

                        </div>
                        <div class="as-line__as-D" :style="{
                            width: `${ getValueWithMode('away', 'firstGoalScoredPercentage_overall', false, false) }%`
                        }">

                        </div>
                    </div>
                </div>
                <div class="as-item__right">
                    <span>{{ getValueWithMode('away', 'firstGoalScoredPercentage_overall', false, false) }}%</span>
                    <span>Ghi bàn đầu tiên trong {{ getValueWithMode('away', 'firstGoalScored_overall', false, false) }}/{{ getValueWithMode('away', 'seasonMatchesPlayed_overall', false, false) }} trận</span>
                </div>
            </div>
        </div>
        <div class="as-goals-per-minute">
            <h5>Bàn thắng theo phút</h5>
        </div>
        <div class="as-history">
            <div class="as-history-item">
                <div class="as-history-item__head">
                    <div class="as-head-tab as-uppercase" :class="{ 'as-active': activeTab === 'all' }" @click="setActiveTab('all')">
                        TS bàn thắng
                    </div>
                    <div class="as-head-tab as-uppercase" :class="{ 'as-active': activeTab === 'scored' }" @click="setActiveTab('scored')">
                        Đã ghi bàn
                    </div>
                    <div class="as-head-tab as-uppercase" :class="{ 'as-active': activeTab === 'conceded' }" @click="setActiveTab('conceded')">
                        Bị thủng lưới
                    </div>
                </div>
                <div class="as-history-item__body">
                    <div class="as-competition">
                        <table class="as-competition__table">
                            <thead>
                                <tr>
                                    <th>Mỗi 10 phút</th>
                                    <th class="as-center a">{{ footyStats?.home_name }}</th>
                                    <th class="as-center a">{{ footyStats?.away_name }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>0 - 10 phút</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', `goals_${activeTab}_min_0_to_10`))}`">{{ getValueWithMode('home', `goals_${activeTab}_min_0_to_10`) }}%</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', `goals_${activeTab}_min_0_to_10`))}`">{{ getValueWithMode('away', `goals_${activeTab}_min_0_to_10`) }}%</td>
                                </tr>
                                <tr>
                                    <td>11 - 20 phút</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', `goals_${activeTab}_min_11_to_20`))}`">{{ getValueWithMode('home', `goals_${activeTab}_min_11_to_20`) }}%</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', `goals_${activeTab}_min_11_to_20`))}`">{{ getValueWithMode('away', `goals_${activeTab}_min_11_to_20`) }}%</td>
                                </tr>
                                <tr>
                                    <td>21 - 30 phút</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', `goals_${activeTab}_min_21_to_30`))}`">{{ getValueWithMode('home', `goals_${activeTab}_min_21_to_30`) }}%</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', `goals_${activeTab}_min_21_to_30`))}`">{{ getValueWithMode('away', `goals_${activeTab}_min_21_to_30`) }}%</td>
                                </tr>
                                <tr>
                                    <td>31 - 40 phút</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', `goals_${activeTab}_min_31_to_40`))}`">{{ getValueWithMode('home', `goals_${activeTab}_min_31_to_40`) }}%</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', `goals_${activeTab}_min_31_to_40`))}`">{{ getValueWithMode('away', `goals_${activeTab}_min_31_to_40`) }}%</td>
                                </tr>
                                <tr>
                                    <td>41 - 50 phút</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', `goals_${activeTab}_min_41_to_50`))}`">{{ getValueWithMode('home', `goals_${activeTab}_min_41_to_50`) }}%</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', `goals_${activeTab}_min_41_to_50`))}`">{{ getValueWithMode('away', `goals_${activeTab}_min_41_to_50`) }}%</td>
                                </tr>
                                <tr>
                                    <td>51 - 60 phút</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', `goals_${activeTab}_min_51_to_60`))}`">{{ getValueWithMode('home', `goals_${activeTab}_min_51_to_60`) }}%</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', `goals_${activeTab}_min_51_to_60`))}`">{{ getValueWithMode('away', `goals_${activeTab}_min_51_to_60`) }}%</td>
                                </tr>
                                <tr>
                                    <td>61 - 70 phút</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', `goals_${activeTab}_min_61_to_70`))}`">{{ getValueWithMode('home', `goals_${activeTab}_min_61_to_70`) }}%</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', `goals_${activeTab}_min_61_to_70`))}`">{{ getValueWithMode('away', `goals_${activeTab}_61_to_70`) }}%</td>
                                </tr>
                                <tr>
                                    <td>71 - 80 phút</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', `goals_${activeTab}_min_71_to_80`))}`">{{ getValueWithMode('home', `goals_${activeTab}_min_71_to_80`) }}%</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', `goals_${activeTab}_min_71_to_80`))}`">{{ getValueWithMode('away', `goals_${activeTab}_min_71_to_80`) }}%</td>
                                </tr>
                                <tr>
                                    <td>81 - 90 phút</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', `goals_${activeTab}_min_81_to_90`))}`">{{ getValueWithMode('home', `goals_${activeTab}_min_81_to_90`) }}%</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', `goals_${activeTab}_min_81_to_90`))}`">{{ getValueWithMode('away', `goals_${activeTab}_min_81_to_90`) }}%</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="as-competition">
                        <table class="as-competition__table">
                            <thead>
                                <tr>
                                    <th>Mỗi 15 phút</th>
                                    <th class="as-center a">{{ footyStats?.home_name }}</th>
                                    <th class="as-center a">{{ footyStats?.away_name }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>0 - 15 phút</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', `goals_${activeTab}_min_0_to_15`))}`">{{ getValueWithMode('home', `goals_${activeTab}_min_0_to_15`) }}%</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', `goals_${activeTab}_min_0_to_15`))}`">{{ getValueWithMode('away', `goals_${activeTab}_min_0_to_15`) }}%</td>
                                </tr>
                                <tr>
                                    <td>16 - 30 phút</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', `goals_${activeTab}_min_16_to_30`))}`">{{ getValueWithMode('home', `goals_${activeTab}_min_16_to_30`) }}%</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', `goals_${activeTab}_min_16_to_30`))}`">{{ getValueWithMode('away', `goals_${activeTab}_min_16_to_30`) }}%</td>
                                </tr>
                                <tr>
                                    <td>31 - 45 phút</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', `goals_${activeTab}_min_31_to_45`))}`">{{ getValueWithMode('home', `goals_${activeTab}_min_31_to_45`) }}%</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', `goals_${activeTab}_min_31_to_45`))}`">{{ getValueWithMode('away', `goals_${activeTab}_min_31_to_45`) }}%</td>
                                </tr>
                                <tr>
                                    <td>46 - 60 phút</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', `goals_${activeTab}_min_46_to_60`))}`">{{ getValueWithMode('home', `goals_${activeTab}_min_46_to_60`) }}%</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', `goals_${activeTab}_min_46_to_60`))}`">{{ getValueWithMode('away', `goals_${activeTab}_min_46_to_60`) }}%</td>
                                </tr>
                                <tr>
                                    <td>61 - 85 phút</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', `goals_${activeTab}_min_61_to_85`))}`">{{ getValueWithMode('home', `goals_${activeTab}_min_61_to_85`) }}%</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', `goals_${activeTab}_min_61_to_85`))}`">{{ getValueWithMode('away', `goals_${activeTab}_min_61_to_85`) }}%</td>
                                </tr>
                                <tr>
                                    <td>85 - 90 phút</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', `goals_${activeTab}_min_86_to_90`))}`">{{ getValueWithMode('home', `goals_${activeTab}_min_86_to_90`) }}%</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', `goals_${activeTab}_min_86_to_90`))}`">{{ getValueWithMode('away', `goals_${activeTab}_min_86_to_90`) }}%</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
    import IconGoalScored from '~src/components/icons/foot_stats/IconGoalScored.vue';
    import type { IMatch } from '~src/interfaces';
    import type { IFootyStats, ITeam, IStatsParent } from '~src/interfaces/footystats';
    import { ref } from 'vue';
import { getClassForItem, getImageUrl } from '~src/helpers/footystats';

    interface Props{
        match: IMatch;
        mode?: string;
        footyStats: IFootyStats | null;
        homeTeamInfo: ITeam | null;
        awayTeamInfo: ITeam | null;
    }

    const props = withDefaults(defineProps<Props>(),{
        mode: 'as-win'
    })

    const activeTab = ref('all')
    const setActiveTab = (tab: string) => {
        activeTab.value = tab;
    };


    const getValueWithMode = (team = 'home', mode = 'btts', is_percent = true, is_last_x = true) => {
        const __data: IStatsParent | null = 
            props.footyStats 
                ? (team === 'home' 
                    ? props.footyStats.home_team_last_x 
                    : props.footyStats.away_team_last_x) 
                : null;

        // let __key = `${mode}_${team}`;
        let __key = `${mode}`;
        if (!__data || !__data.stats || !__data.stats.hasOwnProperty(__key)) {
            return 0; 
        }
        
        const __stats = __data.stats;

        let __total: number = Number(__stats.seasonMatchesPlayedGoalTimingRecorded_overall ?? 0);

        if (activeTab.value === 'scored') {
            __total = Number(props?.footyStats?.season_data?.goalTimingsRecorded_num ?? 0);
        } else if (activeTab.value === 'conceded') {
            __total = Number(props?.footyStats?.season_data?.cornerTimingRecorded_matches_overall ?? 0);
        }

        let res: number = Number(__stats[__key] ?? 0);
        if(!is_last_x){
            const __data: ITeam | null = 
            props.footyStats 
                ? (team === 'home' 
                    ? props.footyStats.home_team_info 
                    : props.footyStats.away_team_info) 
                : null;
            if(!__data?.stats || !__data.stats.stats){
                return 0;
            }    

            return (__data.stats.stats[__key] > 100 ? 100 : __data.stats.stats[__key]) as number;
        }
        if(!is_percent){
            return res;
        }

        if(__total){
            let _percent = (res / __total) * 100 

            return Math.floor(_percent); 

            // return `${res} - ${__total} - ${Math.floor(_percent)}`; 
        }

        return 0
        
    }

</script>
<script lang="ts">
export default {};
</script>